import s from './InDevPage.module.scss';

const InDevPage = () => {
  return (
    <div className={s.wrapper}>
      <div className={s.title}>Раздел находится в разработке!</div>
      <div className={s.description}>можно помочь донатиком на пирожочек ( ⓛ ﻌ ⓛ *)</div>
    </div>
  );
};

export default InDevPage;
